const themeLight = {
  mainColor: '#1E88E5',
  secundaryColor: '#C7C7C7',
  background1: '#FAFAFA',
  background2: '#F0F0F0',
  mainTextColor: '#333333',
};

export default themeLight;
